import React, { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { signOut } from '../lib/supabase'

export default function MobileNav() {
  const { isAdmin } = useAuth()
  const navigate = useNavigate()
  const [showMore, setShowMore] = useState(false)

  const handleSignOut = async () => { await signOut(); navigate('/login') }

  const Item = ({ to, icon, label }) => (
    <NavLink to={to} className={({ isActive }) => `mobile-more-item${isActive ? ' active' : ''}`} onClick={() => setShowMore(false)}>
      <span style={{ fontSize: '1.1rem' }}>{icon}</span>
      <span>{label}</span>
    </NavLink>
  )

  return (
    <>
      {/* ── Bottom bar ─────────────────────────────── */}
      <nav className="mnav">
        <NavLink to="/dashboard" className={({ isActive }) => `mnav-item${isActive ? ' active' : ''}`}>
          <span className="mnav-icon">🏠</span><span className="mnav-label">Home</span>
        </NavLink>
        <NavLink to="/farm-log" className={({ isActive }) => `mnav-item${isActive ? ' active' : ''}`}>
          <span className="mnav-icon">🌱</span><span className="mnav-label">Farm Log</span>
        </NavLink>
        <NavLink to="/cash-log" className={({ isActive }) => `mnav-item${isActive ? ' active' : ''}`}>
          <span className="mnav-icon">💵</span><span className="mnav-label">Cash</span>
        </NavLink>
        <NavLink to="/inventory" className={({ isActive }) => `mnav-item${isActive ? ' active' : ''}`}>
          <span className="mnav-icon">🏪</span><span className="mnav-label">Stores</span>
        </NavLink>
        <button className="mnav-item" onClick={() => setShowMore(s => !s)}>
          <span className="mnav-icon">☰</span><span className="mnav-label">More</span>
        </button>
      </nav>

      {/* ── More drawer ────────────────────────────── */}
      {showMore && (
        <div className="mobile-more-overlay" onClick={() => setShowMore(false)}>
          <div className="mobile-more-sheet" onClick={e => e.stopPropagation()}>
            <div className="mobile-more-handle" />
            <div className="mobile-more-header">
              <span style={{ fontFamily:"'Cormorant Garamond',serif", fontWeight:700, fontSize:'1rem' }}>Kobflo Greentek</span>
              <button onClick={() => setShowMore(false)} style={{ background:'none', border:'none', fontSize:'1.2rem', cursor:'pointer', color:'var(--text-muted)' }}>✕</button>
            </div>

            <div className="mobile-more-section">OPERATIONS</div>
            <Item to="/tasks"       icon="✅" label="My Tasks" />
            <Item to="/crop-cycles" icon="🌿" label="Crop Cycles" />
            <Item to="/harvest"     icon="🌾" label="Harvest Log" />
            <Item to="/quality"     icon="🔍" label="Quality Control" />
            <Item to="/logistics"   icon="🚚" label="Logistics" />

            <div className="mobile-more-section">SALES & FINANCE</div>
            <Item to="/sales-orders" icon="🛒" label="Sales Orders" />
            <Item to="/customers"    icon="🤝" label="Customers" />
            <Item to="/invoices"   icon="📄" label="Invoices" />
            <Item to="/weekly-pl"  icon="📊" label="Weekly P&L" />

            <div className="mobile-more-section">PROCUREMENT</div>
            <Item to="/requisitions"   icon="📋" label="Requisitions" />
            <Item to="/procurement"    icon="📦" label="Purchase Orders" />
            <Item to="/goods-received" icon="📥" label="Goods Received" />
            <Item to="/payables"       icon="💸" label="Payables" />

            <div className="mobile-more-section">INSIGHTS</div>
            <Item to="/ml-insights" icon="🧠" label="Smart Insights" />

            <div className="mobile-more-section">PEOPLE & SAFETY</div>
            <Item to="/staff-register" icon="👥" label="Staff Register" />
            <Item to="/timesheets"     icon="⏱️" label="Timesheets" />
            <Item to="/visitors"       icon="👤" label="Visitor Log" />
            <Item to="/incidents"      icon="🚨" label="Incident Reports" />
            <Item to="/sops"           icon="📋" label="SOPs & Guides" />
            <Item to="/emergency"      icon="🆘" label="Emergency Plan" />

            {isAdmin && (
              <>
                <div className="mobile-more-section">ADMIN & FINANCE</div>
                <Item to="/fixed-assets"          icon="🏗️" label="Fixed Assets" />
                <Item to="/loans"                 icon="🏦" label="Loans" />
                <Item to="/financial-statements"  icon="📊" label="Financial Statements" />
                <Item to="/journal-ledger"  icon="📒" label="Journal Ledger" />
                <Item to="/equity"  icon="🏦" label="Equity & Capital" />
                <Item to="/admin/users"            icon="👥" label="Manage Users" />
                <Item to="/admin/settings"         icon="⚙️" label="Settings" />
                <Item to="/admin/reports"          icon="📈" label="Reports" />
              </>
            )}

            <div style={{ padding:'16px 20px', borderTop:'1px solid var(--border)', marginTop:8 }}>
              <button onClick={handleSignOut} style={{ width:'100%', padding:'12px', background:'var(--red-pale)', color:'var(--red)', border:'1px solid var(--red)', borderRadius:8, fontWeight:700, cursor:'pointer', fontFamily:'inherit', fontSize:'0.9rem' }}>
                🚪 Sign Out
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
